import React from 'react';
import { Quote } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-24 bg-light">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <div className="h-[1px] w-12 bg-gold mx-auto"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-playfair font-bold text-dark mb-6">
              La Maîtrise du Détail
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto">
              Chez <span className="font-semibold text-gold">JENMA Concept</span>, nous maîtrisons l'agencement 
              au millimètre près. Chaque projet est une œuvre unique où la technique rencontre l'esthétique, 
              où la précision s'allie à la créativité.
            </p>
          </div>
          
          <div className="relative bg-white p-12 rounded-sm shadow-luxury">
            <Quote className="absolute top-8 left-8 w-12 h-12 text-gold/20" />
            <blockquote className="relative z-10 text-center">
              <p className="text-2xl md:text-3xl font-playfair italic text-dark leading-relaxed mb-6">
                Chaque ligne tracée est une promesse de justesse
              </p>
              <cite className="text-sm text-gray-600 tracking-wider uppercase not-italic">
                Notre engagement qualité
              </cite>
            </blockquote>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="text-center">
              <div className="text-4xl font-playfair font-bold text-gold mb-2">15+</div>
              <p className="text-sm text-gray-600 uppercase tracking-wide">Années d'expérience</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-playfair font-bold text-gold mb-2">200+</div>
              <p className="text-sm text-gray-600 uppercase tracking-wide">Projets réalisés</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-playfair font-bold text-gold mb-2">100%</div>
              <p className="text-sm text-gray-600 uppercase tracking-wide">Satisfaction client</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
